export default "__VITE_ASSET__B1AEajV8__"